import { combineEpics } from "redux-observable";
import { epicLoginChatServer } from "./epics/epicLoginChatServer";
import { epicPostInChatRoom } from "./epics/epicPostInChatRoom";
export var epicChat = combineEpics(epicLoginChatServer, epicPostInChatRoom);



//////////////////
// WEBPACK FOOTER
// ./src/features/chat/epicChat.ts
// module id = 1793
// module chunks = 3